<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Profile</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-address-book" />
            Profile
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CCard class="custom-form-card mb-3">
        <CCardBody>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                invalid-feedback="This input is required."
                label="Email"
                label-for="profile-email"
                :state="profileData.email.isValid"
              >
                <b-form-input
                  v-model="profileData.email.value"
                  :state="profileData.email.isValid"
                  placeholder="Email"
                  maxlength="50"
                  id="profile-email"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                :invalid-feedback="profileData.currentPassword.feedback"
                label="Current Password"
                label-for="profile-currentPassword"
                :state="profileData.currentPassword.isValid"
              >
                <b-form-input
                  v-model="profileData.currentPassword.value"
                  type="password"
                  :state="profileData.currentPassword.isValid"
                  placeholder="Current Password"
                  maxlength="50"
                  id="profile-currentPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                :invalid-feedback="profileData.newPassword.feedback"
                label="New Password"
                label-for="profile-newPassword"
                :state="profileData.newPassword.isValid"
              >
                <b-form-input
                  v-model="profileData.newPassword.value"
                  type="password"
                  :state="profileData.newPassword.isValid"
                  placeholder="New Password"
                  maxlength="50"
                  id="profile-newPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                :invalid-feedback="profileData.confirmNewPassword.feedback"
                label="New Password (repeat)"
                label-for="profile-confirmNewPassword"
                :state="profileData.confirmNewPassword.isValid"
              >
                <b-form-input
                  v-model="profileData.confirmNewPassword.value"
                  type="password"
                  :state="profileData.confirmNewPassword.isValid"
                  placeholder="New Password (repeat)"
                  maxlength="50"
                  id="profile-confirmNewPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          
          <CRow>
            <CCol class="col-12">
              <CButton color="primary" class="float-right" type="submit" style="width:7rem" :disabled="isSubmitting || isLoading" @click="editProfile">
                <b-spinner small v-if="isSubmitting" />
                {{ isSubmitting ? 'Sedang diproses...' : 'Save' }}
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'Profile',
  data() {
    return {
      isSubmitting: false,
      isLoading: false,

      profileData: {
        id: '',
        email: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "email"
        },
        currentPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: false,
          payloadKey: "currentPassword"
        },
        newPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: false,
          payloadKey: "newPassword"
        },
        confirmNewPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: false,
          payloadKey: "confirmNewPassword"
        },
      },
    }
  },
  methods: {

    clearInputFields() {
      this.profileData.currentPassword.value = ''
      this.profileData.newPassword.value = ''
      this.profileData.confirmNewPassword.value = ''
    },

    editProfile(e) {
      e.preventDefault()

      this.isSubmitting = true
      let isFormValid = true

      let currentPassword = this.profileData.currentPassword
      if (currentPassword.isRequired && this.$helper.isEmpty(currentPassword.value)) {
        currentPassword.feedback = "This input is required."
        isFormValid = false
        currentPassword.isValid = false
      } else{
        currentPassword.isValid = null
      }

      let newPassword = this.profileData.newPassword
      if (newPassword.isRequired && this.$helper.isEmpty(newPassword.value)) {
        newPassword.feedback = "This input is required."
        isFormValid = false
        newPassword.isValid = false
      } else if (!this.$helper.isEmpty(currentPassword.value) && newPassword.value.length < 6) {
        newPassword.feedback = "Password should contain a minimum of 6 characters."
        isFormValid = false
        newPassword.isValid = false
      // } else if (!this.$helper.containsSmallLetter(newPassword.value) || !this.$helper.containsCapitalLetter(newPassword.value)) {
      //   newPassword.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
      //   isFormValid = false
      //   newPassword.isValid = false
      // } else if (!this.$helper.containsNumber(newPassword.value)) {
      //   newPassword.feedback = "Password should contain number [0-9]."
      //   isFormValid = false
      //   newPassword.isValid = false
      // } else if (!this.$helper.containsSpecialCharacter(newPassword.value)) {
      //   newPassword.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
      //   isFormValid = false
      //   newPassword.isValid = false
      } else{
        newPassword.isValid = null
      }

      let confirmNewPassword = this.profileData.confirmNewPassword
      if (confirmNewPassword.isRequired && this.$helper.isEmpty(confirmNewPassword.value)) {
        confirmNewPassword.feedback = "This input is required."
        isFormValid = false
        confirmNewPassword.isValid = false
      } else if (newPassword.value != confirmNewPassword.value) {
        confirmNewPassword.feedback = "Please repeat the same password."
        isFormValid = false
        confirmNewPassword.isValid = false
      } else{
        confirmNewPassword.isValid = null
      }

      if (isFormValid) {
        // URL builder
        let putUrl = "/profile"
        let obj = {
          email: this.profileData.email.value,
          current_password: this.$helper.isEmpty(this.profileData.currentPassword.value) ? null : this.profileData.currentPassword.value,
          new_password: this.$helper.isEmpty(this.profileData.newPassword.value) ? null : this.profileData.newPassword.value,
        }
  
        this.$axios.put(putUrl, obj).then(response => {
          if(response.status == 200){
            if (response.data.success){
              this.$helper.toastSuccess(this, "Edit Profile Berhasil! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
              this.clearInputFields()
            } else{
              this.$helper.toastError(this, "Edit Profile Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
            }
          }
          else{
            this.$helper.toastError(this, "Edit Profile Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit Profile Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Edit Profile Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      } else{
        this.isSubmitting = false
      }
    },

    getProfile() {
      this.profileData.email.value = localStorage.getItem("cctvEmail")
      // this.isLoading = true

      // // URL builder
      // let getUrl = "/profile"
      // let params = {}

      // this.$axios.get(getUrl, {params: params}).then(response => {
      //   if(response.status == 200){
      //     this.profileData.id = response.data.data.id
      //     this.profileData.email.value = response.data.data.email
      //   }
      //   else{
      //     this.$helper.toastError(this, "Load Profile Gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
      //   }
      // })
      // .catch(error => {
      //   if(!this.$helper.isEmpty(error.response)){
      //     this.$helper.toastError(this, "Load Profile Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
      //   }
      //   else{
      //     this.$helper.toastError(this, "Load Profile Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
      //   }
      // })
      // .finally(() => {
      //   this.isLoading = false
      // })
    },

  },
  created() {
    this.getProfile()
  },
}
</script>

<style>

</style>
